import React from "react";
import "assets/styles/home/IntegralSolutionHome.scss";
import Title from "components/common/sections/Title";

const IntegralSolutionHome = () => {
  return (
    <div className={'integralSolutionWrapper'}>
      <div className={'integralSolution'}>
        <Title text={"Impulsa tu negocio con ETOMIN"} position={"center"} />
        <h3 className={'subtitle'}>Tu crecimiento, nuestra prioridad</h3>

        <div className={'content'}>
          <p>
            En ETOMIN, hacemos que vender en línea sea sencillo, seguro y sin complicaciones.
            Con nuestra Solución Integral, transformamos tu negocio en una operación digital completamente funcional, lista para aceptar pagos en minutos.
          </p>

          <p>
            Sabemos que digitalizar un negocio puede parecer complejo, por eso, nosotros nos ocupamos de cada detalle. Desde la planeación estratégica hasta la implementación técnica, te entregamos una plataforma lista para operar.
          </p>

          <h4>Nuestra solución incluye:</h4>

          <ul className={'features'}>
            <li>
              <strong>Estrategia y consultoría personalizada:</strong> Analizamos tu modelo de negocio y tu mercado para definir la mejor ruta digital y de pagos.
            </li>
            <li>
              <strong>Diseño y desarrollo web profesional:</strong> Creamos tu sitio o tienda en línea con un diseño moderno, adaptable y optimizado para convertir visitas en ventas.
            </li>
            <li>
              <strong>Pasarela de pagos segura y flexible:</strong> Integramos nuestra tecnología de pagos con soporte para tarjetas y cumplimiento PCI DSS, garantizando operaciones seguras y confiables.
            </li>
            <li>
              <strong>Automatización de cobros y liquidaciones:</strong> Tus transacciones se procesan y liquidan de forma automática, con reportes transparentes y acceso en tiempo real.
            </li>
            <li>
              <strong>Soporte continuo:</strong> Nuestro equipo técnico y operativo te acompaña en todo momento para mantener tu negocio digital en marcha, sin interrupciones.
            </li>
          </ul>

          <p className={'closing'}>
            En ETOMIN, te entregamos una solución digital completa, escalable y lista para crecer contigo.
          </p>

          <p>
            Con tecnología comprobada, procesos seguros y la experiencia de un aliado experto en medios de pago, tu negocio podrá ingresar al mundo del comercio electrónico sin estrés, sin demoras y con total confianza.
          </p>

          <p className={'cta'}>
            <strong>¡Contáctanos para más información!</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default IntegralSolutionHome;
